import React, { useEffect, useState } from 'react'
import PaymentMethodInfo from './components/PaymentMethodInfo'
import PaymentMethodSelection from './components/PaymentMethodSelection'
import PaymentDetails from './components/PaymentDetails'
import SecurityProtection from './components/SecurityProtection'
import DepositRequest from './DepositRequest';
import { GetAccountsApi } from '../../../../api/request/transfer'
import toast from 'react-hot-toast'
import { YourWallet } from '../../../../api/request/dashboard'
import { useSelector } from 'react-redux'

const Deposit3 = () => {
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
    const [isRefresh, setIsRefresh] = useState(false);
    const [showPaymentDetails, setShowPaymentDetails] = useState(false);
    const [depositAmount, setDepositAmount] = useState(0);
    const [accounts, setAccounts] = useState([]);
    const [walletBalance, setWalletBalance] = useState(0)
    const { userDetails } = useSelector((state) => state.user);

    const handlePaymentMethodSelect = (method) => {
        setSelectedPaymentMethod(method);
    };

    const handleDepositClick = (amount) => {
        setDepositAmount(amount);
        setShowPaymentDetails(true);
    };

    const handleBackToSelection = () => {
        setShowPaymentDetails(false);
    };

    const handleSecureDeposit = (formData) => {
        // Handle the actual deposit logic here
        // You can integrate with existing payment components from the components folder
    };

    const getAccounts = async () => {
        // setIsLoading(true);
        try {
            const { data } = await GetAccountsApi(new URLSearchParams({ FilterText: "Approved" }).toString());

            if (data?.success) {
                setAccounts(data?.data?.filter((account) => account?.isLive));
            }
        } catch (error) {
            if (error?.response?.data?.error?.message)
                toast.error(error?.response?.data?.error?.message);
        }
    }


    const getWalletBalance = async () => {
        try {
            const { data } = await YourWallet(userDetails?.id);
            if (data?.success) {
                setWalletBalance(data?.data?.balance);
            }
        } catch (error) {
            if (error?.response?.data?.error?.message)
                toast.error(error?.response?.data?.error?.message);
        }
    }


    // Sample payment method data for PaymentMethodInfo component
    const paymentMethodData = selectedPaymentMethod ? {
        fees: selectedPaymentMethod.fee === 'Free' ? 'Free' : selectedPaymentMethod.fee,
        processingTime: selectedPaymentMethod.processingTime,
        minAmount: selectedPaymentMethod.minAmount.replace('$', '').replace(',', ''),
        maxAmount: selectedPaymentMethod.maxAmount.replace('$', '').replace(',', '')
    } : null;

    useEffect(() => {
        getAccounts();
        getWalletBalance();
    }, [])



    return (
        <div className="min-h-screen py-3">
            <>
                {/* Payment Method Info - Show only when a method is selected */}
                <div className="mt-3">
                    <PaymentMethodInfo paymentMethod={paymentMethodData} walletBalance={walletBalance} />
                </div>

                {/* Payment Method Selection */}
                {!showPaymentDetails ? <PaymentMethodSelection
                    onMethodSelect={handlePaymentMethodSelect}
                    selectedMethod={selectedPaymentMethod}
                    onDepositClick={handleDepositClick}
                /> :
                    <PaymentDetails
                        amount={depositAmount}
                        paymentMethod={selectedPaymentMethod}
                        accounts={accounts}
                        onBack={handleBackToSelection}
                        onSecureDeposit={handleSecureDeposit}
                        walletBalance={walletBalance}
                        resetAll={() => {
                            setShowPaymentDetails(false);
                            setSelectedPaymentMethod(null);
                            setDepositAmount(0);
                            setIsRefresh(true);
                        }}
                    />
                }

                {/* Security & Protection Section */}
                <SecurityProtection />

                <div className=' md:p-6 p-2 border-2 border-light rounded-md mt-3'>
                    <DepositRequest
                        isRefresh={isRefresh}
                        setIsRefresh={setIsRefresh}
                        onDepositClick={handleDepositClick}
                    />
                </div>
            </>


        </div>
    )
}

export default Deposit3